
import promiseErrors from '~/services/promiseErrors';

export default {
    name: 'Groups',
    async asyncData({ app, store }) {
        const endpoint = app.$config.endpoints.group;

        const requests = [app.$axios.$get(endpoint, { params: { per_page: 5, page: 1 } })];
        if (store.state.auth.loggedIn) {
            requests.push(app.$axios.$get(endpoint, { params: { per_page: 5, page: 1, user: store.state.auth.user.slug } }));
        }

        const [groups, myGroups] = await promiseErrors(requests, app);

        return {
            groups: groups ? groups.groups.data : [],
            myGroups: myGroups ? myGroups.groups.data : [],
        };
    },
    data() {
        return {
            groups: [],
            myGroups: [],
        };
    },
    methods: {
        async joinGroup(group) {
            const { message } = await this.$axios.$put(`${this.$config.endpoints.group}/${group.slug}/join`, {
                user: this.$store.state.auth.user,
            });
            this.$store.dispatch('setFlashMessage', { message });
        },
        search(data = {}) {
            const params = {
                ...(data.keyword && { keyword: data.keyword }),
            };
            this.$router.push({ name: 'groups-search-keyword', params });
        },
    },
};
